import './icon-list-simple.scss';
